import { DateTimeConverter } from 'src/app/core/services/mapper/converters';
import { ContactInteraction } from './contact-interaction.model';
import { Interlocuteur } from './interlocuteur.model';
import { RefTypeInteraction } from './ref-type-interaction.model';
import { ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';
import * as moment from 'moment';

export class Interaction {
    static jsonMap = {
        id: { key: 'id', optional: true },
        dateInteraction: { key: 'dateInteraction', converter: new DateTimeConverter(), optional: true },
        contact: { key: 'contact', converter: new (ClassConverterFactory.build(ContactInteraction))(), optional: true },
        contact_anpp: { key: 'contact_interlocuteur', converter: new (ClassConverterFactory.build(Interlocuteur))(), optional: true },
        refTypeInteraction: { key: 'refTypeInteraction', converter: new (ClassConverterFactory.build(RefTypeInteraction))(), optional: true },
        sujetInteraction: { key: 'sujet', optional: true, default: '' },
        compteRendu: { key: 'compteRendu', optional: true, default: '' }
    };

    public id: number;
    dateInteraction: moment.Moment;
    public contact: ContactInteraction;
    public contact_anpp: Interlocuteur;
    public refTypeInteraction: RefTypeInteraction;
    public sujetInteraction: string;
    public compteRendu: string;
}
